








import Vue from 'vue'

export default Vue.extend({
    name: 'ScrollTop',
    data(){
        return { lastScrollTop:0 }
    },
    created(){
        document.addEventListener('scroll', this.handleScroll)
    },
    destroyed(){
        document.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        handleScroll(){
            let st = window.pageYOffset || document.documentElement.scrollTop
            let btn = this.$refs.scrollTopBtn as Element;
            btn.classList.toggle('scroll_up', (!(st > this.lastScrollTop) && st != 0))
            btn.classList.toggle('hidden', st < window.innerHeight / 2)
            this.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        },
        toTop(){
            let scrollStep = -window.scrollY / (250 / 15),
                scrollInterval = setInterval(function(){
                if ( window.scrollY != 0 ) {
                    window.scrollBy( 0, scrollStep );
                }
                else clearInterval(scrollInterval); 
            },15);
        }
    }
})
